export default __webpack_public_path__ + "static/media/crosshairs-gps.d67b127e.svg";